<template>
  <section class="mb-3">
    <div class="row">
      <div class="col-md-8 offset-md-2 col-12">
        <div class="card">
          <div class="card-body shadow-sm">
            <h2 class="text-center mt-2">
              {{ $t('message.scope_of_service') }}
            </h2>
            <div
              class="p-2"
              v-html="($i18n.locale === 'th') ? globalState.services[parentServiceId].detail_th : globalState.services[parentServiceId].detail_en"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      currentStep: 1,
      displayBookingInfo: false,
      parentServiceId: 1
    }
  },
  computed: {
    ...mapGetters({
      globalState: 'globalVal/getState'
    })
  },
  mounted () {
    if (typeof this.$route.query.sid === 'undefined') {
      this.parentServiceId = 1
    } else {
      this.parentServiceId = Number(this.$route.query.sid)
    }
  }
}
</script>

<style scoped>
  div >>> ol {
    padding-left: 1rem !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/booking/components/ServiceDetail.vue